import { useAtom } from 'jotai';
import React, { FunctionComponent, useState } from 'react';

import { Search } from '@mui/icons-material';
import {
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Box,
  MenuItem,
  Select,
} from '@mui/material';

import {
  currentPageIndexAtom,
  pageSizeAtom,
  searchKeywordAtom,
  startRowAtom,
} from '../utils/AtomConfig';

export const SearchBox: FunctionComponent = () => {
  const [, setSearchKeyword] = useAtom(searchKeywordAtom);
  const [pageSize, setPageSize] = useAtom(pageSizeAtom);
  const [, setCurrentPageIndex] = useAtom(currentPageIndexAtom);
  const [, setStartRow] = useAtom(startRowAtom);
  const [keyword, setKeyword] = useState('');

  function handleKeyUp(event: any) {
    setKeyword(event.target.value);
    if (event.key === 'Enter') {
      setSearchKeyword(event.target.value);
    }
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ flexGrow: 1 }}>
        <FormControl
          sx={{ width: '100%', maxWidth: '640px', paddingRight: 1 }}
          variant='filled'
        >
          <InputLabel htmlFor='search-by-keyword'>Search</InputLabel>
          <FilledInput
            id='search-by-keyword'
            type='text'
            onKeyUp={handleKeyUp}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='search by keyword'
                  onClick={() => setSearchKeyword(keyword)}
                  edge='end'
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Box>
      <Box>
        <FormControl sx={{ width: '100px' }}>
          <InputLabel htmlFor='page-size'>Page Size</InputLabel>
          <Select
            id='page-size'
            value={pageSize}
            label='Page size'
            onChange={(event) => {
              setCurrentPageIndex(1);
              setStartRow(0);
              setPageSize(event.target.value as number);
            }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};
